const KEYS = {
  ENTER: 'Enter'
}

export default KEYS
